var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Dashboard") },
                    model: {
                      value: _vm.settings.Home.Dashboard,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Dashboard", $$v)
                      },
                      expression: "settings.Home.Dashboard",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Inbox") },
                    model: {
                      value: _vm.settings.Home.Inbox,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Inbox", $$v)
                      },
                      expression: "settings.Home.Inbox",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Settings") },
                    model: {
                      value: _vm.settings.Home.Settings,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Settings", $$v)
                      },
                      expression: "settings.Home.Settings",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("contacts"))),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Custommers") },
                    model: {
                      value: _vm.settings.Home.Custommers,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Custommers", $$v)
                      },
                      expression: "settings.Home.Custommers",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Suppliers") },
                    model: {
                      value: _vm.settings.Home.Suppliers,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Suppliers", $$v)
                      },
                      expression: "settings.Home.Suppliers",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Prospects") },
                    model: {
                      value: _vm.settings.Home.Prospects,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Prospects", $$v)
                      },
                      expression: "settings.Home.Prospects",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("products"))),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Products") },
                    model: {
                      value: _vm.settings.Home.Products,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Products", $$v)
                      },
                      expression: "settings.Home.Products",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("PriceLists") },
                    model: {
                      value: _vm.settings.Home.PriceLists,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "PriceLists", $$v)
                      },
                      expression: "settings.Home.PriceLists",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Stock") },
                    model: {
                      value: _vm.settings.Home.Stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Stock", $$v)
                      },
                      expression: "settings.Home.Stock",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("sales"))),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Sales") },
                    model: {
                      value: _vm.settings.Home.Sales,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Sales", $$v)
                      },
                      expression: "settings.Home.Sales",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("FrequencyDocuments") },
                    model: {
                      value: _vm.settings.Home.FrequencyDocuments,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "FrequencyDocuments", $$v)
                      },
                      expression: "settings.Home.FrequencyDocuments",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("SaleRows") },
                    model: {
                      value: _vm.settings.Home.SaleRows,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "SaleRows", $$v)
                      },
                      expression: "settings.Home.SaleRows",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("purchases"))),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Purchases") },
                    model: {
                      value: _vm.settings.Home.Purchases,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Purchases", $$v)
                      },
                      expression: "settings.Home.Purchases",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("PurchaseDocuments") },
                    model: {
                      value: _vm.settings.Home.PurchaseDocuments,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "PurchaseDocuments", $$v)
                      },
                      expression: "settings.Home.PurchaseDocuments",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: {
                      space: "",
                      label: _vm.$ct("PurchaseDocumentRows"),
                    },
                    model: {
                      value: _vm.settings.Home.PurchaseDocumentRows,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "PurchaseDocumentRows", $$v)
                      },
                      expression: "settings.Home.PurchaseDocumentRows",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("financial"))),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Bank") },
                    model: {
                      value: _vm.settings.Home.Bank,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Bank", $$v)
                      },
                      expression: "settings.Home.Bank",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Bookkeeping") },
                    model: {
                      value: _vm.settings.Home.Bookkeeping,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Bookkeeping", $$v)
                      },
                      expression: "settings.Home.Bookkeeping",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("tools"))),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Crm") },
                    model: {
                      value: _vm.settings.Home.Crm,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Crm", $$v)
                      },
                      expression: "settings.Home.Crm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Projects") },
                    model: {
                      value: _vm.settings.Home.Projects,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Projects", $$v)
                      },
                      expression: "settings.Home.Projects",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Calendar") },
                    model: {
                      value: _vm.settings.Home.Calendar,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Calendar", $$v)
                      },
                      expression: "settings.Home.Calendar",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Tasks") },
                    model: {
                      value: _vm.settings.Home.Tasks,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Tasks", $$v)
                      },
                      expression: "settings.Home.Tasks",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { space: "", label: _vm.$ct("Car") },
                    model: {
                      value: _vm.settings.Home.Car,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings.Home, "Car", $$v)
                      },
                      expression: "settings.Home.Car",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }